import { isObjectEmpty } from '../../../common/src/utils/objectUtils';
import { isValid, format, parse } from 'date-fns';
import { retrievePartyById } from '../../../common/src/legacy/services/apiRouterService';
import { Address } from '../../../../types/Common';
import { isRiskAnalysisFlow } from '../../../common/src/utils/globalVariables';
import { getI18nCountryCode } from '../../../../i18n';
import store from '../../../flows/src/store/redux/store';
import { updateAnswers } from '../../../flows/src/store/redux/slices/flowsSlice';

interface PrefillParams {
  first_name?: string;
  last_name?: string;
  birth?: string;
  email?: string;
  phone?: string;
  street?: string;
  boxnr?: string;
  housenr?: string;
  zipcode?: string;
  city?: string;
  party_id?: string;
  address?: Address;
  language?: string;
  country_code?: string;
}
const groupIdNatural = isRiskAnalysisFlow()
  ? 'policy_holder.personal_information'
  : 'policy_holder.natural_info';

const fillParamValues = (paramObject: PrefillParams, isParty?: boolean) => {
  const { dispatch } = store;
  let addressObj: Address = {};
  const {
    first_name,
    last_name,
    birth,
    email,
    phone,
    street,
    boxnr,
    housenr,
    zipcode,
    city,
    address,
    language,
    country_code,
  } = paramObject;
  Object.keys(paramObject as PrefillParams).forEach((paramKey) => {
    if (!paramObject[paramKey]) return;
    switch (paramKey) {
      case 'first_name': {
        dispatch(
          updateAnswers({
            id: 'policy_holder.first_name',
            answer: first_name,
            groupId: groupIdNatural,
            prefilled: true,
          }),
        );
        break;
      }
      case 'last_name': {
        dispatch(
          updateAnswers({
            id: 'policy_holder.last_name',
            answer: last_name,
            groupId: groupIdNatural,
            prefilled: true,
          }),
        );
        break;
      }
      case 'birth': {
        if (isParty) {
          dispatch(
            updateAnswers({
              id: 'policy_holder.birth',
              answer: birth ? new Date(birth).toISOString() : null,
              groupId: groupIdNatural,
              prefilled: true,
            }),
          );
        } else if (birth && isValid(new Date(birth.replaceAll('/', '-')))) {
          const date = format(
            parse(birth.replaceAll('/', '-'), 'dd-MM-yyyy', new Date()),
            'dd/MM/yyyy',
          );
          dispatch(
            updateAnswers({
              id: 'policy_holder.birth',
              answer: new Date(date).toISOString(),
              groupId: groupIdNatural,
              prefilled: true,
            }),
          );
        }
        break;
      }
      case 'email': {
        dispatch(
          updateAnswers({
            id: 'policy_holder.email',
            answer: email,
            groupId: isRiskAnalysisFlow()
              ? groupIdNatural
              : 'policy_holder.contact',
            prefilled: true,
          }),
        );
        break;
      }
      case 'language': {
        dispatch(
          updateAnswers({
            id: 'policy_holder.language',
            answer: language,
            groupId: groupIdNatural,
            prefilled: true,
          }),
        );
        break;
      }
      case 'phone': {
        dispatch(
          updateAnswers({
            id: 'policy_holder.telephonenr',
            answer: phone,
            groupId: 'policy_holder.contact',
            prefilled: true,
          }),
        );
        break;
      }
      case 'street': {
        addressObj['street'] = street;
        break;
      }
      case 'boxnr': {
        addressObj['boxnr'] = boxnr;
        break;
      }
      case 'housenr': {
        addressObj['housenr'] = housenr;
        break;
      }
      case 'city': {
        addressObj['city'] = city;
        break;
      }
      case 'zipcode': {
        addressObj['zipcode'] = zipcode;
        break;
      }
      case 'address': {
        if (isParty) {
          addressObj = address as Address;
        }
        break;
      }
      case 'country_code': {
        addressObj['country_code'] = country_code;
        break;
      }

      default:
        return;
    }
  });

  if (!isObjectEmpty(addressObj)) {
    if (!country_code) {
      addressObj['country_code'] = getI18nCountryCode();
    }

    dispatch(
      updateAnswers({
        id: 'policy_holder.address',
        answer: addressObj,
        groupId: isRiskAnalysisFlow()
          ? 'policy_holder.address'
          : 'policy_holder.natural_location',
        prefilled: true,
      }),
    );
  }
};

export const setDefaultValuesFromParams = async (
  params: string,
): Promise<void> => {
  if (params) {
    const paramObject = JSON.parse(params);
    if (paramObject.party_id) {
      const [resp, status] = await retrievePartyById(paramObject.party_id);
      if (status === 200) {
        const obj = {
          ...resp,
          phone: resp?.telephonenr,
          language: resp?.native_language,
        };
        fillParamValues(obj, true);
      }
    } else {
      fillParamValues(paramObject);
    }
  }
};
